import { Button, Form, FormInstance, Input, Modal } from "antd";
import React from "react";
import { CreateHallFloorPayload, CreateHallPayload } from "../../interfaces";
import TextArea from "antd/lib/input/TextArea";

interface Props {
  open: boolean;
  onCancel: () => void;
  loading: boolean;
  form: FormInstance<CreateHallFloorPayload>;
  initialValues: CreateHallFloorPayload;
  onFinish: ((values: CreateHallFloorPayload) => void) | undefined;
}

const CreateHallFloorForm = ({
  open,
  onCancel,
  loading,
  form,
  initialValues,
  onFinish,
}: Props) => {
  return (
    <Modal
      title="Add Floor"
      open={open}
      onCancel={onCancel}
      footer={[
        <Button type="default" key="cancel" onClick={() => onCancel()}>
          Close
        </Button>,
        <Button
          form="hallForm"
          key="submit"
          htmlType="submit"
          type="primary"
          loading={loading}
        >
          {loading ? "Saving..." : "Save"}
        </Button>,
      ]}
    >
      <Form<CreateHallFloorPayload>
        form={form}
        layout="vertical"
        id="hallForm"
        name="hallForm"
        initialValues={initialValues}
        onFinish={onFinish}
      >
        <Form.Item
          name="name"
          label="Floor Name"
          rules={[
            {
              required: true,
              message: "Please input the name of the floor!",
            },
          ]}
        >
          <Input type="text" size="large" />
        </Form.Item>
        <Form.Item name="description">
          <TextArea allowClear size="large" rows={5} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateHallFloorForm;
